import axios from 'axios';
import { getAccessToken } from './shared';
import { showWarningSnackbar } from '../components/snackBar/snakbar';
import { axiosInstanceForLambda } from './Axios';
import API_ENDPOINTS from '../apiEndpoints';
import { entityOptions } from '../utils/customerData';
import { isValidGSTIN } from '../utils/Regex';

export const FetchGstInDetails = async (gstin) => {
  const normalizedGstin = (gstin || '').toString().trim().toUpperCase();

  if (!isValidGSTIN(normalizedGstin)) {
    showWarningSnackbar('Invalid GSTIN format');
    throw {
      code: 'INVALID_GSTIN_FORMAT',
      message: 'Invalid GSTIN format',
      status: null,
      raw: null,
    };
  }

  try {
    const options = {
      method: 'GET',
      url: `${API_ENDPOINTS.REACT_APP_FETCH_GSTIN_URL}?gstin=${normalizedGstin}`,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    };

    const response = await axiosInstanceForLambda(options);
    return response;
  } catch (error) {
    console.log(error, 'error');

    const errorData = error?.response?.data || {};
    const errorCode = errorData?.error_cd;
    if (errorCode === 'F08000' || errorCode === 'SWEB_9035') {
      showWarningSnackbar('Invalid GSTIN as per GST Portal');
    } else if (error?.code === 'ERR_NETWORK') {
      showWarningSnackbar( 'Network error. Please check your internet connection');
    } else {
      showWarningSnackbar('GSTIN Portal is currently unavailable. Unable to validate or fetch details. Please enter details manually');
    }

    // 🔥 IMPORTANT: rethrow
    throw {
      code: errorCode || error?.code,
      message: '',
      status: error?.response?.status,
      raw: error,
    };
  }
};

const constitutionToEntityMap = {
  'PUBLIC LIMITED COMPANY': 'PublicLtd',
  'PRIVATE LIMITED COMPANY': 'PvtLtd',
  'LIMITED LIABILITY PARTNERSHIP': 'LLP',
  LLP: 'LLP',
  PROPRIETORSHIP: 'Proprietorship',
  PROPRIETARY: 'Proprietorship',
  INDIVIDUAL: 'Individual',
  'HINDU UNDIVIDED FAMILY': 'HUF',
  HUF: 'HUF',
  GOVERNMENT: 'Government',
  TRUST: 'Trust',
  'ASSOCIATION OF PERSONS': 'AOP',
  AOP: 'AOP',
  'BODY OF INDIVIDUALS': 'BOI',
  BOI: 'BOI',
  PARTNERSHIP: 'Firm',
  'PARTNERSHIP FIRM': 'Firm',
  FIRM: 'Firm',
  'LOCAL AUTHORITY': 'LocalAuthority',
  'ARTIFICIAL JURIDICAL PERSON': 'ArtificialJuridicalPerson',
  AJP: 'ArtificialJuridicalPerson',
};

const normalizeConstitution = (value = '') => value.toString().trim().replace(/\s+/g, ' ').toUpperCase();

export const resolveEntityTypeFromGstin = ({ gstin = '', constitutionOfBusiness = '' } = {}) => {
  // Keep same approach used in customer flow: derive entity from PAN identifier in GSTIN.
  const entityChar = gstin?.trim()?.toUpperCase()?.charAt(5);
  const byPanIdentifier = entityOptions.find((ent) => ent?.panIdentifier === entityChar)?.id;
  if (byPanIdentifier) {
    return byPanIdentifier;
  }

  const normalizedConstitution = normalizeConstitution(constitutionOfBusiness);
  return constitutionToEntityMap[normalizedConstitution] || '';
};
